import { render } from "./SessionLiveData.vue?vue&type=template&id=55c04fb9&scoped=true"
import script from "./SessionLiveData.vue?vue&type=script&lang=js"
export * from "./SessionLiveData.vue?vue&type=script&lang=js"

import "./SessionLiveData.vue?vue&type=style&index=0&id=55c04fb9&scoped=true&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c04fb9"]])

export default __exports__